<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}
.lang-width {
  width: 450px !important;
}
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
.tabChange{
  width: 100%;
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  align-content: flex-end;
 
}
::v-deep .el-tabs__content {
    overflow: visible;
  }  
  ::v-deep .el-tabs__item {
    color: black;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #15cbf3;
  }
  ::v-deep .el-icon-arrow-left {
    color: black;
  }
  ::v-deep .el-icon-arrow-right {
    color: black;
  }
  ::v-deep .el-tabs__nav-wrap::after {
    height: 0;
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #15cbf3;
  }


</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="tabChange">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="信息列表" name="improvement"></el-tab-pane>
        <el-tab-pane label="车型列表" name="vehicleModel"></el-tab-pane>
      </el-tabs>
    </div>

    <div class="list-content-div">
      <div class="list-header-title-div">用户信息完善列表</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="list-query-child-div flex" style="align-items:center;" v-if="tabFlag">
          <div class="query-title-div">时间筛选阶段</div>
          <div class="query-inputs-div flex-1">
            <el-date-picker
              v-model="searchTime"
              style="width: 100%;"
              type="daterange"
              size="small"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="handleDateChange"
            ></el-date-picker>
          </div>
        </div>
        <!-- <div class="list-query-child-div flex " style="align-items:center;margin-left:10px;">
          <div class="query-title-div">时间筛选类型</div>
          <div class="query-inputs-div">
            <el-radio-group v-model="queryInfo.filterType">
              <el-radio label="01">按日期</el-radio>
              <el-radio label="02">按月份</el-radio>
            </el-radio-group>
          </div>
        </div> -->
        <div class="flex-grow-1"></div>
        <button v-if="tabFlag" class="common-bg-button" @click="getListData(pagination, true)">
          搜 索
        </button>
        <button v-if="tabFlag" class="common-bg-button" @click="reset()">重 置</button>
        <button class="common-bg-button" @click="toExportList()">导出</button>
      </div>

      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="tabFlag?pageConfig.listColumns:pageConfig.listColumns1"
          :operates="operates"
          :tableData="tabFlag?tableData:vehcileTableData"
          :tableConfig="tabFlag?pageConfig.tableConfig:pageConfig.tableConfig1"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
        v-if="tabFlag"
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
        <ZD-pagination
        v-else
          :pagination="pagination"
          v-on:pageUpdate="getVehcile"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tabFlag:true,
      activeName: "improvement",
      tableData: [], // 表格数据
      vehcileTableData:[],
      selections: [], // 表格选项
      searchTime: [],
      radio: "",
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      paidTime: [],
      showMultiQuerys: false,
      operates: {
        width: 220,
        fixed: "right",
        list: [
        
        ],
      }, // 列操作按钮
    };
  },
  methods: {
    //获取数据
    init() {
      // this.getListData(this.pagination, true);
    },
    handleClick(val){
      console.log(val);
      if(val.name == 'vehicleModel'){
        this.tabFlag = false;
        this.getVehcile(this.pagination,true)
      }else{
        this.tabFlag = true
        this.getListData(this.pagination,true)
      }
      
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.pagination.total = 0
      _.tableData = []
      if (!_.searchTime || _.searchTime.length <= 0) {
        return _.$U.error("请选择时间范围");
      }
      
      _.$U.showLoading(_);
     
         _.$H
        .post(_, _.$A.operateStatis.custCompletePage, _.queryInfo)
        .then((res) => {
          _.tableData = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });
    },
    getVehcile(pagination, reload = false){
      let _ = this;
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.$U.showLoading(_);
      _.$H
        .post(_, _.$A.operateStatis.vehcileBindPage, _.queryInfo)
        .then((res) => {
          _.vehcileTableData = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });
    },
    // 选择注册时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.startDate = val[0];
        this.queryInfo.endDate = val[1];
      } else {
        delete this.queryInfo.startDate;
        delete this.queryInfo.endDate;
      }
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    //选择时间
    pickdate(time) {
      console.log(time);
      let _ = this;
      // 拆分时间区间
      _.queryInfo.fromTransactionSucceedTime = time ? time[0] : "";
      _.queryInfo.toTransactionSucceedTime = time ? time[1] : "";
    },
    // 导出
    toExportList() {
      let _ = this;
     
      if( !_.searchTime||_.searchTime.length<=0){
        return _.$U.error("请选择时间范围");
      }
      _.$U.showLoading(_);
      if(_.tabFlag){
         _.$H
        .post(_, _.$A.operateStatis.custCompleteExport, _.queryInfo)
        .then((res) => {
          _.$U.saveExcelFile(res.data.data);
          var downUrl = "http://192.168.8.174:7997" + res.data.data.viewPath;
          // var downUrl = 'http://ocharge.shzhida.com:6777'+res.data.data.viewPath;
          window.open(downUrl, "_blank");
          _.$U.hideLoading(_);
        });
      }else{
        _.$H
        .post(_, _.$A.operateStatis.vehcileBindExport, {})
        .then((res) => {
          _.$U.saveExcelFile(res.data.data);
          var downUrl = "http://192.168.8.174:7997" + res.data.data.viewPath;
          // var downUrl = 'http://ocharge.shzhida.com:6777'+res.data.data.viewPath;
          window.open(downUrl, "_blank");
          _.$U.hideLoading(_);
        });
      }
     
    },
    //重置
    reset() {
      delete this.queryInfo.filterType;
      delete this.queryInfo.startDate;
      delete this.queryInfo.endDate;

      this.searchTime = [];
      // this.getListData(this.pagination, true);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
